"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeToken = exports.setToken = exports.hasToken = exports.getToken = exports.TOKEN_KEY = void 0;
exports.TOKEN_KEY = 'token';
const getToken = () => localStorage.getItem(exports.TOKEN_KEY);
exports.getToken = getToken;
const hasToken = () => localStorage.getItem(exports.TOKEN_KEY) !== null;
exports.hasToken = hasToken;
const setToken = idToken => {
  localStorage.setItem(exports.TOKEN_KEY, idToken);
};
exports.setToken = setToken;
const removeToken = () => {
  localStorage.removeItem(exports.TOKEN_KEY);
};
exports.removeToken = removeToken;
//# sourceMappingURL=storage.js.map